import { TrackJS } from "trackjs";
import {
  TRACK_JS_APPLICATION_KEY,
  TRACK_JS_TOKEN,
} from "helpers/error_reporting/constants";
import { isDevelopment } from "helpers/get_env";

const isTrackJSInstalled = () => {
  return TrackJS && TrackJS.isInstalled();
};

const initErrorReporting = (sessionId: string) => {
  if (TrackJS && !TrackJS.isInstalled() && !isDevelopment()) {
    TrackJS.install({
      token: TRACK_JS_TOKEN,
      application: TRACK_JS_APPLICATION_KEY,
      version: APP_GIT_HASH,
    });
    TrackJS.configure({ sessionId });
  }
};

const addMetadata = (key: string, value: string) => {
  if (isTrackJSInstalled()) {
    TrackJS.addMetadata(key, value);
  }
};

const reportError = (
  error: Error | object | string,
  metadata?: Record<string, string>
) => {
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      addMetadata(key, value);
    });
  }
  if (isTrackJSInstalled()) {
    TrackJS.track(error);
  }
};

export { addMetadata, initErrorReporting, reportError };
